import header from "./living-room-2.png";
import section1 from "./living-room.png";
import section2 from "./art-in-living-room.png";
import section3 from "./kitchen-2.png";
import section4 from "./kitchen.png";

export { header, section1, section2, section3, section4 };
